const getTemplate1 = (text, shipmentId) => {
    text = text.replace(/,/g, ".");
    let pastedRows = text.split("\n");
    let newPackages = [];
    let newPackage = {};
    let newItem = {};
    let cells = [];
    let prevRefNo = "";

    let unitWeight = 0;
    let packageNo = 1;

    pastedRows.forEach((pastedRow) => {
        cells = pastedRow.split("\t");
        if (cells.length !== 18) {
        return;
        }

        if (cells[9] !== "") {
        unitWeight =
            Math.round(
            (Number(cells[13] ?? 0) / Number(cells[12] ?? 1)) * 100,
            ) / 100;

        prevRefNo =
            cells[1] !== ""
            ? `${cells[1]}${
                cells[1] !== "" && cells[2] !== "" ? " + " : ""
                }${cells[2]}`
            : prevRefNo;
        newPackage = {
            packageNo: packageNo,
            shipment_id: shipmentId,
            qty: cells[12] !== "" ? cells[12] : "0",
            unit: "KOLI",
            length: cells[9],
            width: cells[10],
            height: cells[11],
            volume: cells[16],
            unitWeight: unitWeight.toString(),
            totalWeight: cells[13],
            volumeWeight: cells[14],
            chargeable: cells[15],
            chargeableUnit: "kg",
            note: cells[17].trim(),
            ShipmentItems: [
            {
                shipment_id: shipmentId,
                item_no: cells[5],
                ref_no: prevRefNo,
                name: cells[6],
                qty: cells[7] !== "" ? cells[7] : "0",
                unit: cells[8],
                batch_no: "",
                expired: "",
            },
            ],
        };
        newPackages.push(newPackage);
        packageNo++;
        } else {
        newItem = {
            shipment_id: shipmentId,
            item_no: cells[5],
            ref_no:
            cells[1] !== ""
                ? `${cells[1]}${
                    cells[1] !== "" && cells[2] !== "" ? " + " : ""
                }${cells[2]}`
                : prevRefNo,
            name: cells[6],
            qty: cells[7] !== "" ? cells[7] : "0",
            unit: cells[8],
            batch_no: "",
            expired: "",
        };

        newPackages[newPackages.length - 1].ShipmentItems.push(newItem);
        }
    });
    return newPackages;
}

const getTemplate2 = (text, shipmentId) => {
    text = text.replace(/,/g, ".");
    let pastedRows = text.split("\n");
    let newPackages = [];
    let newPackage = {};
    let newItem = {};
    let cells = [];

    pastedRows.forEach((pastedRow) => {
        cells = pastedRow.split("\t");
        if (cells.length !== 16) {
            return;
        }

        if (cells[7] !== "") {
            newPackage = {
                packageNo: cells[0],
                shipment_id: shipmentId,
                qty: cells[11] !== "" ? cells[11] : "0",
                unit: "KOLI",
                length: cells[7],
                width: cells[8],
                height: cells[9],
                volume: cells[14],
                unitWeight: cells[10],
                totalWeight: cells[12],
                volumeWeight: cells[13],
                chargeable: "0",
                chargeableUnit: "kg",
                note: cells[15].trim(),
                ShipmentItems: [
                {
                    shipment_id: shipmentId,
                    item_no: "",
                    ref_no: cells[2],
                    name: cells[1],
                    qty: cells[3] !== "" ? cells[3] : "0",
                    unit: cells[4],
                    batch_no: cells[5],
                    expired: cells[6],
                },
                ],
            };
            newPackages.push(newPackage);
        } else {
            newItem = {
                shipment_id: shipmentId,
                    item_no: "",
                    ref_no: cells[2],
                    name: cells[1],
                    qty: cells[3] !== "" ? cells[3] : "0",
                    unit: cells[4],
                    batch_no: cells[5],
                    expired: cells[6],
            };

            newPackages[newPackages.length - 1].ShipmentItems.push(newItem);
        }
    });
    return newPackages;
}

export const getPackageFromPastedText = (template, text, shipmentId) => {
    switch(template) {
        case 1: 
        default:
            return getTemplate1(text, shipmentId);
        case 2:
            return getTemplate2(text, shipmentId);
    }

}